import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable } from 'rxjs';
import { AccountUpdate } from '../../../../core/model/account-update.model';
import { CompanyDto, CompanyType } from '../../../../core/model/company.model';
import { PartnerAccountView } from '../../../../core/model/partner-account-view.model';
import { MainService } from '../../main.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {

  constructor(
    private _httpService: FlamingoHttpService,
    private _mainService: MainService,
  ) {
  }

  get user(): PartnerAccountView {
    return this._mainService.user as PartnerAccountView;
  }

  set user(value: PartnerAccountView) {
    this._mainService.user = value;
  }

  public getAccount(): Observable<PartnerAccountView> {
    return this._mainService.getAccount() as Observable<PartnerAccountView>;
  }

  public updateAccount(account: AccountUpdate): Observable<PartnerAccountView> {
    return this._mainService.updateAccount(account) as Observable<PartnerAccountView>;
  }

  public saveCompany(companyType: CompanyType, company: CompanyDto): Observable<any> {
    if (companyType == CompanyType.seller) {
      return this._httpService.post('/partner/seller', company);
    }

    return this._httpService.post('/partner/debtor', company);
  }
}
